var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import SvgIcon from "@mui/material/SvgIcon";
var RadioIcon = function (props) { return (React.createElement(SvgIcon, __assign({}, props),
    React.createElement("g", { fillRule: "evenodd" },
        React.createElement("circle", { cx: "12", cy: "12", r: "7", fill: "#FFF" }),
        React.createElement("path", { d: "M12,4 C7.584,4 4,7.584 4,12 C4,16.416 7.584,20 12,20 C16.416,20 20,16.416 20,12 C20,7.584 16.416,4 12,4 Z M12,19 C8.1325,19 5,15.8675 5,12 C5,8.1325 8.1325,5 12,5 C15.8675,5 19,8.1325 19,12 C19,15.8675 15.8675,19 12,19 Z" })))); };
export default RadioIcon;
